var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBagPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.167,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeWidth: 1.139,
    d: "M27.5 21.146v-6.25h-15v12.5H20M16.25 14.896v-2.084c0-1.25 2.083-2.083 3.75-2.083 1.667 0 3.75.834 3.75 2.084v2.083"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M21.563 24.687h6.25M24.688 21.562v6.25"
  }));
}
export default SvgIconBagPlus;